export default {
  'smartChart.openingAvailable': 'Opening Available',
  'smartChart.priorDayDistribution': 'Month to Date Credit/Debit Distribution',
  'smartChart.subTitle': '(Deposit Accounts)',
  'smartChart.title': 'Available Balance'
};
